<template>
    <v-app>
        <!--<v-container class="px-0">-->
            <div class="company hidden-xs-only">Prudent Accounting Services LLC. & Prudent Insurance Brokerage INC.</div>
            <div class="company hidden-sm-and-up" style="font-size: 1em">Prudent Accounting Services LLC. & Prudent Insurance Brokerage INC.</div>
           <Navbar/>
           <router-view/>
            <Social/>
           <v-spacer class="h-space"></v-spacer>
           <Footer/>
       <!--</v-container>-->
   </v-app>
</template>

<script>
   import Navbar from '@/components/layout/Navbar'
   import Footer from '@/components/layout/Footer'
   import Social from '@/components/common/Social'
   import store from '@/vuex/store'

   export default {
       name: 'App',
       components: {
           Navbar, Footer, Social
       },
       store
   }
</script>

<style>
   .company{
       font-family: Impact, Charcoal, sans-serif;
       /*font-family: 'Tangerine', serif;*/
       font-size: 2.5em;
       /*text-shadow: 2px 2px 2px #aaa;*/
       text-align: center;
       color: #8e8e8e;
   }

   .h-space{
       height: 150px;
   }
</style>



// WEBPACK FOOTER //
// src/App.vue